export default __webpack_public_path__ + "static/media/scrollRight1.06183949.jpg";